export enum ItemActions {
    Edit = 1,
    Delete = 2,
    Clone = 3
}